import { Component, OnInit, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnInit {
  icon: string;
  copied: boolean;

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private clipboard: Clipboard,
  ) {}

  ngOnInit() {
    this.icon = this.getIcon();
  }

  getIcon() {
    switch (this.data.snackbarType) {
      case 'Success':
        return 'check_circle';
      case 'Failure':
        return 'error';
      default:
        return null;
    }
  }

  isStringMessage(msg: string): boolean {
    return typeof msg === 'string';
  }

  copyToClipboard(event: MouseEvent) {
    event.stopPropagation();
    let textToCopy = this.data.snackbarType + ' - ';
    if (this.data.title) {
      textToCopy += 'Title: ' + this.data.title + ' Message: ';
    }
    textToCopy += this.data.message;
    if (this.clipboard.copy(textToCopy)) {
      this.copied = true;
    }
  }
}
